export const loadMoreBtnHandler = (appData, currentlyVisibleJobs, setCurrentlyVisibleJobs) => {
	const jobCount = appData.jobs.length;

	if (currentlyVisibleJobs + appData.general.job_count >= jobCount) {
		// If all jobs become visible, unset the currentlyVisibleJobs property
		setCurrentlyVisibleJobs(null);
	} else {
		// If not all jobs are visible, increment the currentlyVisibleJobs property to show more jobs
		setCurrentlyVisibleJobs((currentlyVisibleJobs) => currentlyVisibleJobs + appData.general.job_count);
	}
};

export let timer;
export const handleSearchInput = (e, userData, setUserData) => {
	const key = 'q';
	const inputValue = e.target.value;

	const updatedFilters = { ...userData.taxonomies };

	clearTimeout(timer);
	if (inputValue !== '') {
		updatedFilters[key] = inputValue;

		// Refresh timer before an event is sent to Matomo
		timer = setTimeout(() => {
			window._mtm = window._mtm || [];
			window._mtm.push({ event: 'itdJobs-search', jobSearchTerm: inputValue });
		}, 2000); // Wait 2 seconds until an event is sent
	} else {
		delete updatedFilters[key];
	}

	setUserData({
		...userData,
		taxonomies: updatedFilters,
	});
};

export const handleFilterChange = (taxonomyName, value, isDisabled, userData, setUserData) => {
	// if option is disabled, prevent the click and do nothing.
	if (isDisabled) {
		return;
	}

	const taxonomies = { ...userData.taxonomies };
	if (value.toString() !== '0') {
		// If any value is selected, set the taxonomy and value
		taxonomies[taxonomyName] = value;
	} else {
		// If the dropdown has its initial state, unset the taxonomy
		delete taxonomies[taxonomyName];
	}

	setUserData({
		...userData,
		taxonomies,
	});
};

export const handleFilterClear = (filterName, userData, setUserData) => {
	const updatedFilters = { ...userData.taxonomies };

	// Unset filter
	delete updatedFilters[filterName];

	setUserData({
		...userData,
		taxonomies: updatedFilters,
	});
};

export const resetAllFilters = (userData, setUserData) => {
	setUserData({
		...userData,
		taxonomies: {},
	});
};
